import React from "react";
import { ListBox, Select } from "@heroui/react";

export function PortalSelect({ label, value, onChange, options = [] }) {
  return (
    <label className="portal-field">
      <span className="portal-field__label">{label}</span>
      <Select
        selectedKey={value || undefined}
        onSelectionChange={(key) => onChange?.(key ? String(key) : "")}
        className="w-full"
        fullWidth
        variant="secondary"
        placeholder={label}
      >
        <Select.Trigger>
          <Select.Value />
          <Select.Indicator />
        </Select.Trigger>
        <Select.Popover>
          <ListBox>
            {options.map((opt) => (
              <ListBox.Item key={opt.id} id={opt.id} textValue={opt.label}>
                {opt.label}
                <ListBox.ItemIndicator />
              </ListBox.Item>
            ))}
          </ListBox>
        </Select.Popover>
      </Select>
    </label>
  );
}
